<mat-sidenav-container>
  <mat-sidenav
    id="admin-navigation"
    role="navigation"
    aria-label="Hauptnavigation"
    [mode]="isCompact() ? 'over' : 'side'"
    [opened]="navigationVisible() && (!isCompact() || mobileNavigationOpen())"
    [autoFocus]="isCompact()"
    (openedChange)="onOpenedChange($event)"
  >
    <div class="navigation-container">
      <mat-nav-list>
        @for (nav of navigationItems; track nav.link) {
          <a
            mat-list-item
            [routerLink]="nav.link"
            [routerLinkActive]="'is-nav-item-active'"
            (click)="closeMobileNavigation()"
            >{{ nav.displayName }}</a
          >
        }
      </mat-nav-list>
      <div class="version-info" role="group" aria-label="Versionsinfo">
        <span [title]="commitHash">{{ frontendVersionInfo }}</span>
        <time [attr.datetime]="frontendBuildDate">{{
          frontendBuildDate | date: "medium"
        }}</time>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    @if (navigationVisible() && isCompact()) {
      <div class="mobile-navigation-bar">
        <button
          mat-icon-button
          [attr.aria-label]="
            mobileNavigationOpen()
              ? 'Navigation schließen'
              : 'Navigation öffnen'
          "
          [attr.aria-expanded]="mobileNavigationOpen()"
          aria-controls="admin-navigation"
          (click)="toggleNavigation()"
        >
          <mat-icon>menu</mat-icon>
        </button>
      </div>
    }
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
